import React from 'react';
import { SaveWeatherForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { useParams } from 'react-router-dom';

export type SaveWeatherModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveWeatherModalProps) => {
  const params = useParams();

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save weather'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveWeatherForm.FC
        id={props.id}
        dailyReportId={params.dailyReportId ?? ''}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
